import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b48ae97"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uf-stores__body" }
const _hoisted_2 = { class: "uf-stores__info" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-exanbue__title" }, [
  /*#__PURE__*/_createTextVNode("审核结果 "),
  /*#__PURE__*/_createElementVNode("i", null, "*")
], -1))
const _hoisted_4 = { style: {"margin-top":"15px"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line",
  style: {"margin-top":"15px"}
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-exanbue__title2" }, "审核意见", -1))
const _hoisted_7 = { class: "desc" }
const _hoisted_8 = { class: "uf-button" }
const _hoisted_9 = { class: "uf-button--footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: _ctx.innerShow,
    "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.innerShow) = $event)),
    position: "right",
    style: { height: '100%', width: '100%' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_van_nav_bar, {
          title: "关闭审核",
          "left-text": "返回",
          "left-arrow": "",
          onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.innerShow = false))
        }),
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(["uf-exanbue__button", { 'uf-exanbue__button--active': _ctx.state.state === '1' }]),
              style: {"margin-right":"15px"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.state = '1'))
            }, " 通过 ", 2),
            _createElementVNode("div", {
              class: _normalizeClass(["uf-exanbue__button", { 'uf-exanbue__button--active': _ctx.state.state === '2' }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.state = '2'))
            }, " 驳回 ", 2)
          ]),
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_van_field, {
              modelValue: _ctx.state.desc,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.desc) = $event)),
              rows: "4",
              autosize: "",
              type: "textarea",
              maxlength: "200",
              placeholder: "请填写报修内容",
              "show-word-limit": ""
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_van_button, {
              class: "btn",
              block: "",
              color: "#3d6eeb",
              square: "",
              type: "success",
              onClick: _ctx.submit
            }, {
              default: _withCtx(() => [
                _createTextVNode("提交 ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}